import { Injectable, signal } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  readonly isProductionEnvironment = signal<boolean>(environment.production);

  getPrivilegeEnv(): 'prod' | 'test' {
    return environment.production ? 'prod' : 'test';
  }
}
